import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import { useFilters } from '@lib/context';

import Search from '@svg/search-white.svg';

const SearchBox = ({ currentRefinement, refine, setSearchOpen }) => {
  const { updateSearchQuery } = useFilters();
  const breakpoints = useBreakpoint();
  return breakpoints.lg ? (
    <input
      type='text'
      value={currentRefinement}
      onChange={(event) => {
        refine(event.currentTarget.value);
        updateSearchQuery(event.currentTarget.value);
      }}
      placeholder='Search'
      className='rounded-full bg-teal bg-opacity-10 border-0 focus:ring-0 focus:border-0 w-[658px] text-teal blockH8 placeholder:text-teal placeholder:blockH8 px-6 -mr-[53px]'
    />
  ) : (
    <div className='flex items-center justify-between border-b border-white'>
      <input
        type='text'
        value={currentRefinement}
        onChange={(event) => {
          refine(event.currentTarget.value);
          updateSearchQuery(event.currentTarget.value);
        }}
        placeholder='Search'
        className='pb-4 text-white placeholder:text-white blockH4 placeholder:blockH4 w-full bg-teal border-0 focus:ring-0 focus:border-0 px-0'
      />
      <button onClick={() => setSearchOpen && setSearchOpen(false)}>
        <Search />
      </button>
    </div>
  );
};

export const FilterSearchBox = connectSearchBox(SearchBox);
